import { createAction, props } from '@ngrx/store';
import { Message } from '../_models';

// Action types
export const loadMessages = createAction('[Message] Load Messages');
export const loadMessagesSuccess = createAction(
  '[Message] Load Messages Success',
  props<{ messages: Message[] }>()
);
export const loadMessagesFailure = createAction(
  '[Message] Load Messages Failure',
  props<{ error: any }>()
);

export const addMessage = createAction('[Message] Add Message', props<{ message: Message }>());
export const addMessageSuccess = createAction(
  '[Message] Add Message Success',
  props<{ message: Message }>()
);
export const addMessageFailure = createAction(
  '[Message] Add Message Failure',
  props<{ error: any }>()
);

export const updateMessage = createAction(
  '[Message] Update Message',
  props<{ message: Message }>()
);
export const updateMessageSuccess = createAction(
  '[Message] Update Message Success',
  props<{ message: Message }>()
);
export const updateMessageFailure = createAction(
  '[Message] Update Message Failure',
  props<{ error: any }>()
);

export const deleteMessage = createAction('[Message] Delete Message', props<{ id: number }>());
export const deleteMessageSuccess = createAction(
  '[Message] Delete Message Success',
  props<{ id: number }>()
);
export const deleteMessageFailure = createAction(
  '[Message] Delete Message Failure',
  props<{ error: any }>()
);
